/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArchitectsControllerFindOneQueryResponse, ArchitectsControllerFindOnePathParams, ArchitectsControllerFindOneQueryParams, ArchitectsControllerFindOne400, ArchitectsControllerFindOne401, ArchitectsControllerFindOne403, ArchitectsControllerFindOne404 } from "../../models/architectsController/ArchitectsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { architectsControllerFindOne } from "../../clients/architectsService/architectsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const architectsControllerFindOneQueryKey = (id: ArchitectsControllerFindOnePathParams["id"], params: ArchitectsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/architects/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ArchitectsControllerFindOneQueryKey = ReturnType<typeof architectsControllerFindOneQueryKey>;
export function architectsControllerFindOneQueryOptions(id: ArchitectsControllerFindOnePathParams["id"], params?: ArchitectsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = architectsControllerFindOneQueryKey(id, params);
  return queryOptions<ArchitectsControllerFindOneQueryResponse, ResponseErrorConfig<ArchitectsControllerFindOne400 | ArchitectsControllerFindOne401 | ArchitectsControllerFindOne403 | ArchitectsControllerFindOne404>, ArchitectsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return architectsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get an architect by ID
 * {@link /api/v1/architects/:id}
 */
export function useArchitectsControllerFindOne<TData = ArchitectsControllerFindOneQueryResponse, TQueryData = ArchitectsControllerFindOneQueryResponse, TQueryKey extends QueryKey = ArchitectsControllerFindOneQueryKey>(id: ArchitectsControllerFindOnePathParams["id"], params?: ArchitectsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ArchitectsControllerFindOneQueryResponse, ResponseErrorConfig<ArchitectsControllerFindOne400 | ArchitectsControllerFindOne401 | ArchitectsControllerFindOne403 | ArchitectsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? architectsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...architectsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ArchitectsControllerFindOne400 | ArchitectsControllerFindOne401 | ArchitectsControllerFindOne403 | ArchitectsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}